import { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"

export const useJobValidations = () => {
  const { t } = useTranslation();
  const isRequired = useCallback((value) => {
    if (!value) {
      return t("Job is required");
    }
    return null;
  }, [t]);
  return useMemo(() => [isRequired], [isRequired])
}
